import { render, staticRenderFns } from "./PastCampaign.vue?vue&type=template&id=00f83786&scoped=true&"
import script from "./PastCampaign.vue?vue&type=script&lang=js&"
export * from "./PastCampaign.vue?vue&type=script&lang=js&"
import style0 from "./PastCampaign.vue?vue&type=style&index=0&id=00f83786&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f83786",
  null
  
)

export default component.exports